<template>
  <section>
    <base-container>
      <div class="inner-container">
        <h3 class="title">1.填寫草稿</h3>
        <div class="draft">
          <p>選擇服務</p>
          <div class="selection">
            <el-row :gutter="5">
              <el-col :span="12">
                <el-button
                  @click="activate('purchase')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'purchase' }"
                  type="primary"
                  >代購服務</el-button
                >
              </el-col>
              <el-col :span="12">
                <el-button
                  @click="activate('forward')"
                  class="btn-selection"
                  :class="{ 'is-selected': selectedOption === 'forward' }"
                  type="primary"
                  >代運服務</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </base-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: "purchase",
    };
  },
  methods: {
    activate(option) {
      this.selectedOption = option;
    },
  },
};
</script>


<style scoped>
.inner-container {
  padding: 0 5rem;
}

.title {
  color: #7a3d87;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-weight: 700;
  padding: 4rem 0 2rem 0;
}

.draft {
  margin-top: 3rem;
}

.draft p {
  margin-bottom: 1rem;
}

.selection {
  background-color: #fff;
  border-radius: 12px;
  /* min-width: 990px; */
  padding: 0.3rem;
}

.btn-selection {
  width: 100%;
  padding: 1.3rem;
  border-radius: 12px;
  background-color: #f0f0f0;
  border-color: #f0f0f0;
  color: black;
}

.btn-selection:hover,
.btn-selection:focus {
  background-color: #7a3d87;
  border-color: #7a3d87;
}
.is-selected {
  background-color: #7a3d87;
  border-color: #7a3d87;
  color: #fff;
}
</style>